/**
 * EmptyState — Reusable empty state component for admin tabs.
 * Provides consistent empty feedback with icon, title, subtitle, and optional CTA.
 */
import PropTypes from "prop-types";

export default function EmptyState({ icon = "📭", title, subtitle, cta, onCta, T }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 24px",
        textAlign: "center",
        minHeight: 200,
      }}
    >
      <span style={{ fontSize: 40, marginBottom: 12 }}>{icon}</span>
      <h3
        style={{
          fontSize: 15,
          fontWeight: 700,
          color: T.text,
          margin: "0 0 6px",
        }}
      >
        {title}
      </h3>
      {subtitle && (
        <p style={{ fontSize: 12, color: T.muted, margin: "0 0 16px", maxWidth: 320 }}>
          {subtitle}
        </p>
      )}
      {cta && onCta && (
        <button
          onClick={onCta}
          style={{
            padding: "8px 18px",
            borderRadius: 8,
            border: "none",
            background: T.accent,
            color: T.accentText,
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {cta}
        </button>
      )}
    </div>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  cta: PropTypes.string,
  onCta: PropTypes.func,
  T: PropTypes.object.isRequired,
};
